import { render, staticRenderFns } from "./ebook-products.vue?vue&type=template&id=0b831165&"
import script from "./ebook-products.vue?vue&type=script&lang=js&"
export * from "./ebook-products.vue?vue&type=script&lang=js&"
import style0 from "./ebook-products.vue?vue&type=style&index=0&id=0b831165&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports